import { BGCircle } from 'Components';

export const BGCircles = () => {
  return (
    <>
      <BGCircle
        position={{
          top: 15,
          right: -45,
        }}
        bgColor='white'
        diameterPX={100}
        sx={{
          opacity: '0.3',
        }}
      />
      <BGCircle
        position={{
          bottom: 15,
          left: -45,
        }}
        bgColor='white'
        diameterPX={100}
        sx={{
          opacity: '0.3',
        }}
      />
    </>
  );
};
